import React, { useCallback, useEffect, useRef, useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import { debounce } from "lodash";
import { useMediaQuery } from "react-responsive";
import style from "../BlogPage.module.scss";
import cn from "classnames";
import { IoIosArrowForward } from "react-icons/io";
import { HiOutlineChevronDown, HiOutlineViewList } from "react-icons/hi";
import { BlogSidebarType } from "@/components/page-modules/blog/data/blog.types";
export const BlogSidebar: React.FC<BlogSidebarType> = ({
  blogHeading,
  isOpen,
  setIsOpen
}) => {
  const [pathKey, setPathKey] = useState<string>();
  const isMobile = useMediaQuery({
    query: "(max-width: 1280px)"
  });
  const sidebarUlRef = useRef<HTMLUListElement>(null);
  const scrollToLi = () => {
    if (sidebarUlRef && pathKey) {
      const selectedLi = sidebarUlRef.current?.querySelector(`li[data-key="${pathKey}"]`);
      if (selectedLi) {
        selectedLi.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    }
  };
  const optimizedFn = useCallback(debounce(scrollToLi, 100), [pathKey]);
  useEffect(() => {
    const handleScroll = () => {
      const headings = blogHeading || [];
      let currentHeading = "";
      for (let i = 0; i < headings.length; i++) {
        const item = headings[i];
        const element = document.getElementById(item.key);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100) {
            currentHeading = item.key;
          }
        }
      }
      if (currentHeading !== pathKey) {
        setPathKey(currentHeading as string);
      }
    };
    window.addEventListener("scroll", handleScroll);
    optimizedFn();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathKey, blogHeading]);
  return isMobile ? <div className={cn(style.sidebar__mobile, {
    [style.open]: isOpen
  })} onClick={() => setIsOpen(!isOpen)} data-sentry-component="BlogSidebar" data-sentry-source-file="BlogSidebar.tsx">
      <div>
        <HiOutlineViewList size={24} color="#3C3C3C" data-sentry-element="HiOutlineViewList" data-sentry-source-file="BlogSidebar.tsx" />
        <p className={style.sidebar__title}>Table of contents</p>
        <motion.div animate={{
        rotate: !isOpen ? 0 : 180
      }} data-sentry-element="unknown" data-sentry-source-file="BlogSidebar.tsx">
          <HiOutlineChevronDown size={24} color="#3C3C3C" data-sentry-element="HiOutlineChevronDown" data-sentry-source-file="BlogSidebar.tsx" />
        </motion.div>
      </div>
      <hr />
      <motion.ul animate={{
      display: isOpen ? "block" : "none"
    }} data-sentry-element="unknown" data-sentry-source-file="BlogSidebar.tsx">
        {blogHeading?.map(item => <li className={cn({
        [style.selected]: pathKey === item.key
      })} key={item.key}>
            <Link href={`#${item.key}`}>{item.name}</Link>
          </li>)}
      </motion.ul>
    </div> : <div className={style.sidebar} data-sentry-component="BlogSidebar" data-sentry-source-file="BlogSidebar.tsx">
      <div className={style.sidebar__title}>Table of contents</div>

      <div className={style.sidebar__content}>
        <ul ref={sidebarUlRef}>
          {blogHeading?.map(item => <li className={cn({
          [style.selected]: pathKey === item.key
        })} key={item.key} data-key={item.key}>
              <Link href={`#${item.key}`}>{item.name}</Link>
              <IoIosArrowForward color="#A1A1A1" size={14} />
            </li>)}
        </ul>
      </div>
    </div>;
};